import React from 'react';
import { DynamicType, IBackgroundLayerProps, ILayerProps } from '@meitu/saas-editor-core/es/version-types';
import CssDynamic from './css-dynamic';
import ShaderDynamic from './shader-dynamic';

const style = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: 0,
} as React.CSSProperties;

const mediaStyle: React.CSSProperties = {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
};

const liveLayerStyle: React.CSSProperties = {
    position: 'relative',
    zIndex: 1,
    width: '100%',
    height: '100%',
};

export type DynamicBgLayerMode = 'live' | 'poster';

const DynamicBgLayerContent: React.FC<{
    width: number;
    height: number;
    backgroundLayer: ILayerProps | null;
    mode?: DynamicBgLayerMode;
}> = ({ width, height, backgroundLayer, mode = 'live' }) => {
    if (!backgroundLayer || !backgroundLayer.data) {
        return null;
    }
    const { dynamicInfo, url } = backgroundLayer.data as IBackgroundLayerProps;
    if (!dynamicInfo || dynamicInfo.hidden) return null;

    const posterUrl = dynamicInfo.screenshotUrl || url;
    const renderPoster = posterUrl ? <img src={posterUrl} alt="" style={{ ...mediaStyle, zIndex: 0 }} /> : null;

    if (mode === 'poster') {
        return (
            <div className="c-dynamic-bg-layer" style={style}>
                {renderPoster}
            </div>
        );
    }

    const renderLiveContent = () => {
        if (dynamicInfo.dynamicType === DynamicType.CSS) {
            return (
                <div style={liveLayerStyle}>
                    <CssDynamic name={dynamicInfo.name} />
                </div>
            );
        }
        if (dynamicInfo.dynamicType === DynamicType.Shader) {
            return (
                <div style={liveLayerStyle}>
                    <ShaderDynamic width={width} height={height} dynamicInfo={dynamicInfo} />
                </div>
            );
        }
        if (dynamicInfo.dynamicType === DynamicType.Video) {
            return (
                <video
                    src={url}
                    poster={posterUrl}
                    style={{ ...mediaStyle, zIndex: 1 }}
                    autoPlay
                    muted
                    loop
                    playsInline
                />
            );
        }
        if (dynamicInfo.dynamicType === DynamicType.Webp) {
            return url ? <img src={url} alt="" style={{ ...mediaStyle, zIndex: 1 }} /> : null;
        }
        return null;
    };

    return (
        <div className="c-dynamic-bg-layer" style={style}>
            {renderPoster}
            {renderLiveContent()}
        </div>
    );
};

export default DynamicBgLayerContent;
